import { useState, useEffect } from 'react';
import { Queries } from '../api-queries';
import contentfulClient from '../ContentfulApolloClient';

function useTeamRolesData() {
  const [data, setData] = useState<any>(null);

  async function getClient() {
    const { data } = await contentfulClient.query({ query: Queries.GET_TEAM_ROLES_DATA });

    setData(data);
  }

  useEffect(() => {
    getClient();
  }, []);

  if (data) {
    return { loading: false, data };
  }

  return { loading: true, data: null };
}

export default useTeamRolesData;
